import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import AppShell from '../components/AppShell.tsx';
import ExperimentForm from '../components/ExperimentForm.tsx';
import { apiClient } from '../lib/api.ts';
import type { Experiment } from '../../netlify/functions/_lib/domain.ts';

export default function ExperimentEditPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [experiment, setExperiment] = useState<Experiment | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!id) return;
    void apiClient
      .getExperiment(id)
      .then((data) => setExperiment(data.experiment))
      .catch((err: unknown) => setError(err instanceof Error ? err.message : 'Not found'));
  }, [id]);

  return (
    <AppShell>
      <main className="mx-auto max-w-2xl px-6 py-10">
        <p className="text-sm">
          <Link to={id ? `/app/experiments/${id}` : '/app'} className="text-accent-600 underline underline-offset-4">
            Back to experiment
          </Link>
        </p>
        <h1 className="mt-4 text-3xl">Edit experiment</h1>
        {error ? <p className="mt-4 text-danger">{error}</p> : null}
        {experiment ? (
          <div className="mt-8 rounded-xl border border-border bg-surface p-6 shadow-card">
            <ExperimentForm
              initial={experiment}
              submitLabel="Save changes"
              onSubmit={async (fields) => {
                await apiClient.updateExperiment(experiment.id, fields);
                navigate(`/app/experiments/${experiment.id}`);
              }}
            />
          </div>
        ) : null}
      </main>
    </AppShell>
  );
}
